import React from 'react';
import Image from 'next/image';
import { RatingWidget_Alignment, type RatingWidget as RatingWidgetType } from '../../graphql/generated/schema';
import type { IconType } from '../../components';
import { Icon } from '../../components';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import { toCapitalCase } from '../../utils/changeCase';

const ratingColors = {
  1: '#e12729',
  2: '#e12729',
  3: '#f8cc1b',
  4: '#00b277',
  5: '#00b277',
};

export const RatingWidget: React.FC<RatingWidgetType> = ({
  label,
  rating,
  link,
  description,
  customIcon,
  showProfileImages,
  alignment = RatingWidget_Alignment.Left
}) => {
  const Ratings = (
    <div className={constructClassName([
      styles.container,
      styles[`alignment${toCapitalCase(alignment || 'Left')}` as keyof typeof styles],
    ])}>
      <span className={styles.label}>{label || 'Excellent'}</span>
      <div className={styles.starsContainer}>
        {
          new Array(rating || 5).fill(null).map((_, index) => (
            <div
              key={index}
              className={styles.star}
              style={{
                backgroundColor: customIcon ? 'unset' : ratingColors[rating as keyof typeof ratingColors || 5],
              }}
            >
              <Icon
                key={index}
                icon={customIcon as IconType | null || 'starSharpSharpSolid'}
                fill={customIcon ? ratingColors[rating as keyof typeof ratingColors || 5] : 'white'}
                size={customIcon ? 24 : 16}
              />
            </div>
          ))
        }
      </div>
      <span className={styles.description}>{description}</span>
      {
        showProfileImages && (
          <Image
            src="/images/customerReviewProfileImagesRow.png"
            alt="Customer profile images"
            priority
            width={104}
            height={32}
            quality={100}
          />
        )
      }
    </div>
  );

  if (link) {
    return (
      <a
        className={styles.linkContainer}
        href={`${link}`}
        target="_blank"
        rel="noreferrer"
      >
        {Ratings}
      </a>
    );
  }

  return Ratings;
};
